import { HeartIcon } from './decorations';
import { TransparentRow } from '../Row';
import { TextH2, QuincyRegularText } from '../StyledText';
import { TransparentView } from '../Themed';

export default function WhyYouNeedBumoText() {
  return (
    <TransparentView style={{ alignItems: 'center', paddingVertical: 40 }}>
      <TextH2>Why you need Bumo</TextH2>
      <QuincyRegularText
        style={{
          fontSize: 25,
          maxWidth: 1000,
          textAlign: 'center',
          marginTop: 8,
        }}
      >
        The modern, working parent needs flexible care solutions for peace of
        mind. If you've ever found yourself scrambling for care, we see you and
        we're here for you.
      </QuincyRegularText>

      <TransparentRow
        style={{
          marginTop: 8,
        }}
      >
        <HeartIcon />
        <HeartIcon />
        <HeartIcon />
      </TransparentRow>
    </TransparentView>
  );
}
